import { Loader } from '@devd-client/devd/components';
import { ComponentClass, FunctionComponent, Suspense } from 'react';

type ComponentType<P = Record<string, unknown>> =
  | ComponentClass<P>
  | FunctionComponent<P>;

type Props = Record<string, unknown>;

const SuspenseWrapper = (Component: ComponentType) => (props: Props) =>
  (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );

export default SuspenseWrapper;
